import * as angular from 'angular';

import { IHorizontalBarChart } from '../../models';
import { dataRefreshed } from '../../common/';

export class HorizontalBarChart implements IHorizontalBarChart {
    static controllerId = 'HorizontalBarChart';
    id: string;
    labels: string[];
    data: any[];
    options: any;
    item: any;
    private _valueFunction: (event, data) => any[];

    constructor(private _$scope: angular.IScope) {
    }

    $onInit() {
        this.id = `id${this.item.guid}`;
        const configuration = this.item.configuration;
        if (configuration) {
            if (configuration.labels) {
                this.labels = configuration.labels;
            } else {
                this.labels = [];
            }
        }
        this.options = {
            title: '',
            isTitleVisible: false
        };
        this.data = [];
        const self = this;
        this._$scope.$on(dataRefreshed, (event, data) => {
            if (self._valueFunction) {
                const result = self._valueFunction(event, data);
                self.data = result;
            }
        });
    }
}